/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ browserName: NonNullable<unknown>, browserVersion: NonNullable<unknown> }} Outdatedbrowser_Body1Inputs */

const en_outdatedbrowser_body1 = /** @type {(inputs: Outdatedbrowser_Body1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You're using ${i?.browserName} ${i?.browserVersion}. Some features, like viewing PDF documents, may not work correctly. For the best experience, please update to the latest version.`)
};

/**
* | output |
* | --- |
* | "You're using {browserName} {browserVersion}. Some features, like viewing PDF documents, may not work correctly. For the best experience, please update to the..." |
*
* @param {Outdatedbrowser_Body1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const outdatedbrowser_body1 = /** @type {((inputs: Outdatedbrowser_Body1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outdatedbrowser_Body1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outdatedbrowser_body1(inputs)
});
export { outdatedbrowser_body1 as "outdatedBrowser_body" }